import type { ApiResponseModel } from '@/utils/api/models/api-response-model';
import Http from '@/utils/http';
import { UtilCommon } from '@/utils/utilCommon';

const baseUrl: string = import.meta.env.VITE_FUNDAY_BASE_URL;
const authApi = async (url: string, requestBody: object) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      const errorData = {
        ...(await response.json()),
        status: response.status
      };
      return errorData;
    }
    const data = await response.json();
    const result = data.content;
    return result;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};
export default new (class ArticleView extends Http {
  /** Google驗證 */
  async googleVerify(idToken: string): Promise<any> {
    const body = {
      idToken
    };
    const data = await authApi(`${baseUrl}/Auth/GoogleVerify`, body);
    return data;
  }

  /** Meta驗證 */
  async metaVerify(accessToken: string): Promise<any> {
    const body = {
      accessToken
    };
    const data = await authApi(`${baseUrl}/Auth/FacebookVerify`, body);
    return data;
  }

  /**Line驗證 */
  async lineVerify(token: string): Promise<any> {
    const body = {
      token,
      isIdToken: false
    };
    const data = await authApi(`${baseUrl}/Auth/LineVerify`, body);
    return data;
  }
  async SMSVerification(userData: object): Promise<any> {
    const data = await authApi(`${baseUrl}/Auth/SMSVerification`, userData);
    return data;
  }

  async thirdPartySMSVerification(userData: object): Promise<any> {
    const data = await authApi(`${baseUrl}/Auth/ThirdPartySMSVerification`, userData);
    return data;
  }

  async register(registData: object): Promise<any> {
    const data = await authApi(`${baseUrl}/Auth/Register`, registData);
    return data;
  }

  async thirdPartyRegister(registData: object): Promise<any> {
    const data = await authApi(`${baseUrl}/Auth/ThirdPartyRegister`, registData);
    return data;
  }

  async login(loginData: object): Promise<any> {
    const data = await authApi(`${baseUrl}/Auth/Login`, loginData);
    UtilCommon.initTabsCount();
    return data;
  }
  async forgetPassword(phone: string): Promise<ApiResponseModel<string>> {
    const data = await authApi(`${baseUrl}/Auth/ForgetPassword`, { phone });
    return data
  }
})();
